import React, { useRef, useEffect } from 'react';

import "./ModalContentWrapper.scss";

const ModalContentWrapper = ({onScrollBottomReached, width, columns, children, className }) =>
{
    const refContainer = useRef(null);

    useEffect(() => {
        refContainer.current.scrollTop = 0;
    }, []);

    const isScrollBottomHandlerRequired = () =>
    {
        return onScrollBottomReached !== undefined ;
    }

    const handleScroll = (e) =>
    {
        const diff = parseInt((+e.target.scrollHeight - +e.target.scrollTop),10) ;

        const bottom = ( +diff + 1 === e.target.clientHeight || +diff === e.target.clientHeight );

        if ( bottom && onScrollBottomReached !== undefined )
        {
            onScrollBottomReached();
        }
    }

    const handler = isScrollBottomHandlerRequired() ? handleScroll : null ;

    const style = width !== undefined ? {width: width} : {};

    if ( columns === 2 )
    {
        return (
            <div ref={refContainer} className={"s360-modal-content " + className } onScroll={handler}>
                <div className='modal-two-column' style={style}>
                    { children }
                </div>
            </div>
        )
    }
    else
    {
        return (
            <div ref={refContainer} className={"s360-modal-content " + className } onScroll={handler}>
                <div className='modal-one-column' style={style}>
                    { children }
                </div>
            </div>
        )
    }
}

export default ModalContentWrapper ;